module.exports = __webpack_public_path__ + "static/index_image_1_2-dfc458168ecdff0061646344a288f1d1.jpg";